import clsx from "clsx";
import Warning from "../../src/assets/svg/warning.svg";

export interface FormTextareaProps {
  name: string;
  placeholder: string;
  required: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  width?: string;
  className?: string;
  errors?: string[];
}

export function FormTextarea(props: FormTextareaProps) {
  const {
    name,
    placeholder,
    required = true,
    value,
    onChange,
    width,
    className,
    errors,
  } = props;

  const isError = errors && errors.includes(name);

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={name} className="text-[13px] ">
        {name}
        {required && (
          <span className="text-[13px] pl-1 text-warning-red">*</span>
        )}
      </label>
      <div className="flex flex-col gap-1">
        <textarea
          id={name}
          name={name}
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={onChange}
          maxLength={500}
          className={clsx(
            "inline-flex w-full h-[110px] justify-between rounded border p-3 focus:border-primary-blue appearance-none focus:outline-none resize-none text-sm ",
            isError ? "border-warning-red" : "border-extra-light",
            width,
            className
          )}
        />
        {isError && (
          <div className="flex items-center gap-1 text-xs text-warning-red">
            <img src={Warning} alt="Warning" />
            Ovo polje je obavezno.
          </div>
        )}
      </div>
    </div>
  );
}

export default FormTextarea;
